module.exports = __webpack_public_path__ + "img/p_icon01.2ab5f914.svg";